import { getLocale } from '@umijs/max';

import { createIntl, createIntlCache } from '@/.umi/plugin-locale/localeExports';

import enUS from '../locales/en-US';
import plPL from '../locales/pl-PL';

const messages = {
  'en-US': enUS,
  'pl-PL': plPL,
};

interface StaticIntl {
  formatMessage: (message: { defaultMessage?: string; id: string }) => string;
}

export const staticIntl = (): StaticIntl => {
  const locale = getLocale() as keyof typeof messages;
  const cache = createIntlCache();
  return createIntl({ locale, messages: { ...messages[locale] } }, cache);
};
